// @ts-strict-ignore
import { FC } from 'react';

import classNames from 'classnames';

import { getFormattedPhoneNumber } from 'utils/PhoneUtils';

import { IPatientContact, Language, languageOptionsMap } from 'models/Patient';

import Ticket from 'models/Ticket';

import { usePatientModel } from 'components/Patient/usePatientModel';

interface Props {
  ticket: Ticket;
}

interface ItemProps {
  children: string;
  title: string;
  forceSingleLine?: boolean;
}

const TicketContactItem: FC<ItemProps> = ({ title, forceSingleLine, children }) => (
  <div className="contact-item d-flex flex-column">
    <span className="contact-item-header">{title}</span>
    <span
      className={classNames('contact-item-data', {
        'text-nowrap': forceSingleLine
      })}
    >
      {children}
    </span>
  </div>
);

const TicketContact: FC<Props> = ({ ticket }) => {
  const patient = usePatientModel(ticket.patientId);

  const contactInfo: IPatientContact = {
    relationship: null,
    name: 'Patient',
    phoneNumber: patient?.phone,
    phoneExtension: patient?.phoneExtension,
    language: patient?.language
  };

  const hipaaAuthDate = ticket.operatorTicket?.contactHippaAuthDate || null;

  if (ticket.patientHasContact) {
    const patientContact = patient.getContactById(ticket.operatorTicket.patientContactId);

    if (patientContact) {
      contactInfo.phoneNumber = patientContact.phoneNumber;
      contactInfo.name = patientContact.name;
      contactInfo.relationship = patientContact.relationship;
      contactInfo.phoneExtension = patientContact.phoneExtension;
      contactInfo.language = patientContact.language;
    }
  }

  const { name, relationship, phoneNumber } = contactInfo;
  let languageText = languageOptionsMap[patient?.language || Language.English];
  if (contactInfo.language) {
    languageText = languageOptionsMap[contactInfo.language];
  }
  return (
    <div className="ticket-contact d-flex">
      <TicketContactItem title="Contact">{name}</TicketContactItem>

      {relationship && (
        <TicketContactItem forceSingleLine title="Relationship">
          {relationship}
        </TicketContactItem>
      )}

      {phoneNumber && (
        <TicketContactItem forceSingleLine title="Number">
          {`${getFormattedPhoneNumber(phoneNumber)}${
            contactInfo.phoneExtension ? ` ext. ${contactInfo.phoneExtension}` : ''
          }`}
        </TicketContactItem>
      )}
      <TicketContactItem forceSingleLine title="Language">
        {languageText}
      </TicketContactItem>
      {ticket.patientHasContact && (
        <TicketContactItem forceSingleLine title="HIPAA">
          {hipaaAuthDate ? 'Yes' : 'No'}
        </TicketContactItem>
      )}
    </div>
  );
};

export default TicketContact;
